<template>
  <div class="content-container">
    <search-comp :search-show="true" @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Ngày' }}
                </div>
                <div class="child-w-80">
                  <CalendarSelect
                    v-model="searchParams.dateFrom"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số ngày hiển thị' }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.numOfDays" type="number" />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Hạng phòng</div>
                <div class="child-w-80">
                  <el-select v-model="searchParams.roomLevelId" clearable>
                    <el-option
                      v-for="(roomLevel, index) in roomLevelList"
                      :key="index"
                      :value="roomLevel.id"
                      :label="roomLevel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select v-model="searchParams.hotelId" clearable>
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">Show items</div>
                <div class="checkbox-container flex-wrap" style="height: auto; padding: 10px 10px; gap: 10px">
                  <div class="checks-wrap">
                    <input
                      id="showItem1"
                      v-model="searchParams.item"
                      :value="'AVAILABILITY'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem1">Availability</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem2"
                      v-model="searchParams.item"
                      :value="'RATE'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem2">Rates</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem3"
                      v-model="searchParams.item"
                      :value="'ADULT_RATE'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem3">Extra Adult Rates</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem4"
                      v-model="searchParams.item"
                      :value="'CHILD_RATE'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem4">Extra Child Rates</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem5"
                      v-model="searchParams.item"
                      :value="'MIN_NIGHT'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem5">Min Nights</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem6"
                      v-model="searchParams.item"
                      :value="'MAX_NIGHT'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem6">Max Nights</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem7"
                      v-model="searchParams.item"
                      :value="'CTA'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem7">Close to Arrival(CTA)</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem8"
                      v-model="searchParams.item"
                      :value="'CTD'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem8">Close to Departure(CTD)</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem9"
                      v-model="searchParams.item"
                      :value="'STOP_SELL'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem9">Stop Sell</label>
                  </div>
                  <div class="checks-wrap">
                    <input
                      id="showItem10"
                      v-model="searchParams.item"
                      :value="'RELEASE_PERIOD'"
                      name="showItem"
                      type="radio"
                    />
                    <label for="showItem10">Release Period</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :header-height="60"
        :rows="rows"
        :get-row-class="getRowClass"
        class="agGrid room-availability"
        :context="context"
        dom-layout="scroll"
        :suppress-row-click-selection="true"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getAllHotel } from '@/api/hotel'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import { getHotelLinkDashboard } from '@/api/reception/reception'
import dayjs from 'dayjs'
import CellRenderDateHeader from '@/views/mci/reception/components/CellRenderDateHeader.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'

export default {
  components: {
    CellRenderDateHeader,
    CalendarSelect
  },
  data() {
    return {
      searchParams: {
        dateFrom: dayjs().format('YYYY-MM-DD'),
        numOfDays: 15,
        roomLevelId: null,
        hotelId: null,
        item: 'AVAILABILITY'
      },
      defaultSearchParams: {
        dateFrom: dayjs().format('YYYY-MM-DD'),
        numOfDays: 15,
        roomLevelId: null,
        hotelId: null,
        item: 'AVAILABILITY' // AVAILABILITY, RATE, ADULT_RATE, CHILD_RATE, MIN_NIGHT, MAX_NIGHT, CTA, CTD, STOP_SELL, RELEASE_PERIOD
      },
      context: null,
      columns: [
        {
          headerName: 'Hạng phòng',
          field: 'room_level_nm',
          width: 200
        }
      ],
      rows: [],
      loading: false,

      hotelList: [],
      roomLevelList: []

    }
  },

  mounted() {
    this.searchParams = { ...this.defaultSearchParams }
    this.genDate(this.searchParams.dateFrom, this.searchParams.numOfDays)
    this.getListHotel()
    this.getRoomLevelOptions()
    this.fnGetHotelLinkDashboard()
  },
  beforeMount() {
    this.context = { componentParent: this }
  },

  watch: {
    'searchParams.item'() {
      this.onSearch()
    }
  },

  methods: {
    // utils
    genDate(start, numberOfDates) {
      if (start && numberOfDates) {
        const dateFrom = dayjs(start, 'YYYY-MM-DD')

        const resultCols = [
          {
            headerName: 'Hạng phòng',
            field: 'room_level_nm',
            width: 200
          }
        ]
        switch (this.searchParams.item) {
          case 'AVAILABILITY':
            resultCols.push({
                headerName: 'Độ chêch lệch PMS & CM',
                field: 'diff',
                width: 190,
                cellClass: "grid-cell-centered",
              })
            resultCols.push({
              headerName: 'Availability',
              field: 'rate_plan',
              width: 150
            })
            break
          case 'RELEASE_PERIOD':
            break
          default:
            resultCols.push({
              headerName: 'Rate',
              field: 'rate_plan',
              width: 150
            })
            break;
        }

        for (let i = 0; i < numberOfDates; i++) {
          const col = {
            // headerName: dateFrom.add(i, 'day').format('DD/MM-dddd'),
            field: `Day_${dateFrom.add(i, 'day').format('YYYY-MM-DD')}`,
            headerComponent: 'CellRenderDateHeader',
            headerComponentParams: {
              value: dateFrom.add(i, 'day').format('DD/MM-dddd')
            },
            cellClass: "grid-cell-centered",
          }
          if (numberOfDates > 9) {
            col.maxWidth = 100
            col.minWidth = 100
          } else {
            col.flex = 1
          }
          resultCols.push(col)
        }
        this.columns = resultCols
      }
    },
    getRowClass(params) {
      let color = null

      const hotelId = params.data.hotel_id
      switch (hotelId) {
        // Khách sạn đoàn tàu
        case 46:
          color = 'green'
          break
        // Khu cắm trại
        case 45:
          color = 'yellow'
          break
        // Làng cổ tích
        case 44:
          color = 'red'
          break
        // Nebula
        case 47:
          color = 'purple'
          break
        // Nhà sàn thái
        case 48:
          color = 'brown'
          break
        default:
          color = 'white'
          break
      }
      return 'room-level-row room-level-row--' + color
    },


    // call api
    fnGetHotelLinkDashboard() {
      this.loading = true
      getHotelLinkDashboard(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.rows = []
            let list = _.chain(res.data)
              .groupBy('hotel_nm')
              .map((value, key) => {
                return {
                  groupName: key,
                  groupList: value
                }
              })
              .value()

            list.forEach(group => {
              this.rows.push({
                name: group.groupName,
                isFullWidthRow: true
              })
              group.groupList.forEach(item => this.rows.push(item))
            })

          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    onSearch() {
      this.genDate(this.searchParams.dateFrom, this.searchParams.numOfDays)
      this.fnGetHotelLinkDashboard()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.rows = []
      this.columns = [
        {
          headerName: 'Hạng phòng',
          field: 'room_level_nm'
        },
      ]
      this.onSearch()
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    }
  }
}
</script>

<style>
.checks-wrap {
  margin: 0px 10px 0 0 !important;
}
</style>
